import { services } from '../../services';
var action = "manage/rent-record";

export const rentRecordService = {
    getList,
    getOne,
    insert,
    update,
    remove,
    contract,
    requestTerminate,
    approveTerminate
};

function getList(param = '') {
    return services.restApi(`${action}${param}`, 'GET');
}

function getOne(id) {
    return services.restApi(`${action}/${id}`, 'GET');
}

function insert(object) {
    return services.restApi(`${action}/insert`, 'POST', object);
}

function update(id, object) {
    return services.restApi(`${action}/${id}`, 'PUT', object);
}

function remove(id) {
    return services.restApi(`${action}/${id}`, 'DELETE');
}
function contract(id) {
    return services.restApi(`${action}/contract/${id}`, 'GET');
}

function requestTerminate(object) {
    return services.restApi(`${action}/request-terminate`, 'POST', object);
}

function approveTerminate(object) {
    return services.restApi(`${action}/approve-terminate/`, 'POST', object);
}

